import axios from "../../api/axios";

export const AVAILABILITY_ENDPOINTS = {
  BASE: "availabilities"
};

/**
 * Central error handler
 */
const handleApiError = (error, defaultMessage) => {
  const message =
    error?.response?.data?.message ||
    error.message ||
    defaultMessage;

  throw new Error(message);
};

/**
 * Create new availability
 */
export const createAvailability = async (payload) => {
  try {
    const response = await axios.post(
      AVAILABILITY_ENDPOINTS.BASE,
      payload
    );
    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to create availability");
  }
};

/**
 * Update an existing availability
 */
export const updateAvailability = async (id, payload) => {
  try {
    const url = `${AVAILABILITY_ENDPOINTS.BASE}/${id}`;
    const response = await axios.put(url, payload);
    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to update availability");
  }
};

/**
 * Delete an availability
 */
export const deleteAvailability = async (id) => {
  try {
    const url = `${AVAILABILITY_ENDPOINTS.BASE}/${id}`;
    const response = await axios.delete(url);
    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to delete availability");
  }
};

/**
 * Fetch all availabilities (optionally filter by person_id / role)
 */
export const getAllAvailabilities = async ({
  person_id,
  role
} = {}) => {
  try {
    const response = await axios.get(
      AVAILABILITY_ENDPOINTS.BASE,
      {
        params: {
          person_id,
          role
        }
      }
    );
    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to fetch availabilities");
  }
};

/**
 * Fetch a single availability by ID
 */
export const getAvailabilityById = async (id) => {
  try {
    const url = `${AVAILABILITY_ENDPOINTS.BASE}/${id}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to fetch availability");
  }
};
